import React from 'react';
import styles from '../style.module.css';
import { Stacking } from '../types';
import RadioButton from './RadioButton';

type Props = {
  handleRadioChangeStacking: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  stacking: Stacking;
};

const stackingOptions = ['normal', 'percent', 'undefined'];

const StackingOptions = ({ handleRadioChangeStacking, stacking }: Props) => {
  return (
    <div className={styles.radioButtons}>
      <span>
        <b>Stacking:</b>
      </span>
      {stackingOptions.map((value) => (
        <RadioButton
          name="stacking"
          value={value}
          checked={`${stacking}` === value} // for undefined value this needs to be a string
          onChange={handleRadioChangeStacking}
          label={value}
          key={`input-${value}`}
        />
      ))}
    </div>
  );
};

export default StackingOptions;
